import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Metamodel } from 'app/model/base/model';
import { FabricSqlCopySource } from 'app/model/pipeline/copysource/fabric-sql.copysource';
import { sqlSourceAdapts } from './sql.copysource.adapter';
import { SqlServerCopySourceAdapter } from './sql-server.copysource.adapter';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(FabricSqlCopySource),
    asynchronous: true,
    adapts: sqlSourceAdapts
})
export class FabricSqlCopySourceAdapter extends SqlServerCopySourceAdapter {}
